import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { findBannerType, GetOfferDto, useGetOfferById, useGetSo } from 'src/common';
import { HeaderDataFullDetails } from 'src/components/other/headerDataFullDetails.other';
import { HeaderDataPropertyDetails } from 'src/components/other/headerDataPropertyDetails.other';

export interface HeaderDataDetailRow {
  id?: string;
  label: string | React.ReactNode;
  value: string | React.ReactNode;
  disabled: boolean;
}

interface HeaderDataProps {
  expanded: boolean | null;
  handleStyleExpansion: (value: boolean | null) => void;
}

export const HeaderData: React.FC<HeaderDataProps> = ({ expanded, handleStyleExpansion }) => {
  const [viewType, setViewType] = useState<string | null>(null);
  const location = useLocation();
  const { offer, refetch } = useGetOfferById();
  const { so, refetch: refetchSo } = useGetSo();

  useEffect(() => {
    if (viewType) {
      refetch();
      refetchSo();
    }
  }, [viewType]);

  useEffect(() => {
    const type = findBannerType();
    if (type) {
      handleStyleExpansion(false);
    } else {
      handleStyleExpansion(null);
    }
    setViewType(type ?? null);
  }, [location.pathname]);

  if (!viewType) return null;

  if (viewType === 'full_details' && offer) {
    return <HeaderDataFullDetails offer={offer as GetOfferDto} expanded={expanded} handleStyleExpansion={handleStyleExpansion} />;
  }

  if (viewType === 'property_details' && so) {
    return <HeaderDataPropertyDetails so={so} expanded={expanded} handleStyleExpansion={handleStyleExpansion} />;
  }

  return null;
};
